(function () {
  'use strict';

  var selector = 'img[d-src], img[d-srcset]';
  var observer = null;
  var mutationTimer = null;

  function loadImage(img) {
    if (!img || img.dataset.dsrcLoaded === 'true') return;

    var src = img.getAttribute('d-src');
    var srcset = img.getAttribute('d-srcset');
    if (!src && !srcset) return;

    img.dataset.dsrcLoaded = 'true';
    if (observer) observer.unobserve(img);

    img.addEventListener('load', function () {
      img.removeAttribute('d-src');
      img.removeAttribute('d-srcset');
      delete img.dataset.dsrcLoaded;
    }, { once: true });

    img.addEventListener('error', function () {
      delete img.dataset.dsrcLoaded;
    }, { once: true });

    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
  }

  function observeImage(img) {
    if (!img || img.dataset.dsrcLoaded === 'true') return;
    if (!observer) {
      loadImage(img);
      return;
    }
    observer.observe(img);
  }

  function initLazyImages(root) {
    root = root || document;
    if (root.matches && root.matches(selector)) observeImage(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach(observeImage);
  }

  /* Slider ki baaki slides overflow:hidden mein clip hoti hain, observer unhe nahi pakadta.
     Isliye load ke baad visible gallery ki bachi images bhi load kar do (swipe par blank na aaye). */
  function loadGalleryRest() {
    document.querySelectorAll('.m-media-gallery img[d-src], .m-media-gallery img[d-srcset]').forEach(function (img) {
      if (img.offsetParent !== null) loadImage(img);
    });
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadImage(entry.target);
        });
      }, { rootMargin: '400px 0px', threshold: 0.01 });
    }

    initLazyImages(document);

    if (document.readyState === 'complete') {
      setTimeout(loadGalleryRest, 1500);
    } else {
      window.addEventListener('load', function () {
        setTimeout(loadGalleryRest, 1500);
      }, { once: true });
    }

    if (!document.body || !('MutationObserver' in window)) return;

    new MutationObserver(function (mutations) {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(function () {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) initLazyImages(node);
          });
        });
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();